module.exports = __webpack_public_path__ + "img/donapp_logo.2d610271.png";